/* eslint-disable @typescript-eslint/no-explicit-any */
import { jdiColorFetch } from '../colorFetchV2';
import {
  ICancelOrderRes,
  ICancelOrderReq,
  IOrderListReq,
  IOrderListRes,
  IOrderDetailReq,
  IOrderDetailRes,
  ICancelReasonListRes,
  ILogisticsListRes,
  IDelHistoryOrderRes,
  RefundDetailInfoDTO,
  InvoiceListDTO,
  PreCancelDTO,
} from './order.interface';
// 埋点监控
import {
  ORDER_EVENT_NAMES,
  orderBusinessLogger,
} from '@/utils/logger/instance/orderBusinessLogger';

// 查询订单列表的 API 方法
export const fetchOrderList = async (requestData: IOrderListReq): Promise<IOrderListRes> => {
  const response = await jdiColorFetch('trade_order_getList', {
    bodyQuery: {
      size: '10',
      ...requestData,
    },
  });
  if (response?.error) {
    // 报错需上报错误日志
    try {
      orderBusinessLogger({
        eventName: ORDER_EVENT_NAMES.ORDER_LIST_PAGE_LOAD_FAIL,
        message: {
          error: JSON.stringify(response),
        },
      });
    } catch (err) {}
    return response;
  } else {
    if (response?.code === '200') {
      if (!response?.data) {
        // 报错需上报错误日志
        try {
          orderBusinessLogger({
            eventName: ORDER_EVENT_NAMES.ORDER_LIST_PAGE_LOAD_FAIL,
            message: {
              error: JSON.stringify(response),
            },
          });
        } catch (err) {}
      }
      return response?.data;
    } else {
      // 报错需上报错误日志
      try {
        orderBusinessLogger({
          eventName: ORDER_EVENT_NAMES.ORDER_LIST_PAGE_LOAD_FAIL,
          message: {
            error: JSON.stringify(response),
          },
        });
      } catch (err) {}
      response.error = `API Exceoption ${response?.code}`;
      return response;
    }
  }
};

// 查询订单详情的 API 方法
export const fetchOrderDetail = async (requestData: IOrderDetailReq): Promise<IOrderDetailRes> => {
  const response = await jdiColorFetch('trade_order_get', {
    bodyQuery: { ...requestData },
  });
  if (response?.code !== '200' || !response?.data || response?.error) {
    // 报错需上报错误日志
    try {
      orderBusinessLogger({
        eventName: ORDER_EVENT_NAMES.ORDER_DETAIL_PAGE_LOAD_FAIL,
        message: {
          error: JSON.stringify(response),
        },
      });
    } catch (err) {}
  }
  return response?.data;
};

// 查询取消原因列表的 API 方法
export const fetchCancelReasonList = async (
  requestData: IOrderDetailReq,
): Promise<ICancelReasonListRes> => {
  const response = await jdiColorFetch('trade_order_getCancelReasons', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 删除历史订单的 API 方法
export const delHistoryOrder = async (
  requestData: IOrderDetailReq,
): Promise<IDelHistoryOrderRes> => {
  const response = await jdiColorFetch('trade_order_deleteOrder', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 取消订单的 API 方法
export const cancelOrder = async (requestData: ICancelOrderReq): Promise<ICancelOrderRes> => {
  const response = await jdiColorFetch('trade_order_cancel', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 查询物流信息列表的 API 方法
export const fetchLogisticsList = async (
  requestData: IOrderDetailReq,
): Promise<ILogisticsListRes> => {
  const response = await jdiColorFetch('trade_order_getTrace', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 退款详情
export const orderCancelRefund = async (
  requestData: IOrderDetailReq,
): Promise<RefundDetailInfoDTO> => {
  const response = await jdiColorFetch('trade_order_getOrderRefundInfo', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 查询订单发票列表的 API 方法
export const fetchInvoiceList = async (requestData: IOrderDetailReq): Promise<InvoiceListDTO> => {
  const response = await jdiColorFetch('trade_order_getInvoiceList', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 订单预取消
export const preCancelOrder = async (requestData: IOrderDetailReq): Promise<PreCancelDTO> => {
  const response = await jdiColorFetch('trade_order_preCancel', {
    bodyQuery: { ...requestData },
  });
  return response?.data;
};

// 控制展示ochama订单入口接口
export const getOchamaOrderConfig = async (): Promise<any> => {
  const response = await jdiColorFetch('trade_order_getOchamaOrderConfig', {
    bodyQuery: {},
  });
  return response;
};
